import axios from "axios";

const ADMIN_AUTH_STORAGE_KEY = "admin-login-user";

const getStoredAdminUser = () => {
  try {
    const storedAdminUser = localStorage.getItem(ADMIN_AUTH_STORAGE_KEY);
    return storedAdminUser ? JSON.parse(storedAdminUser) : null;
  } catch {
    localStorage.removeItem(ADMIN_AUTH_STORAGE_KEY);
    return null;
  }
};

const adminHttpCommon = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

adminHttpCommon.interceptors.request.use(
  (config) => {
    const token = config.skipAuth ? null : getStoredAdminUser()?.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

adminHttpCommon.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(ADMIN_AUTH_STORAGE_KEY);
      window.location.href = "/admin-dashboard/login";
    }

    return Promise.reject(error);
  }
);

export default adminHttpCommon;
